<div class="ota-device-key-page">
    <div class="breadcrumb">
		<a [routerLink]="'/dashboard'">Home</a>
		<span class="separator">›</span>
		<span class="current">OTA Audit</span>
	</div>
    
    <div class="main-content">
        <div class="page-header">
			<div>
				<!-- <h2>OTA Device Keys</h2> -->
				<!-- <p>Create signing keys and review previously generated public keys.</p> -->
                 <h2>OTA Audit</h2>
                 <p>Monitor OTA operations for your devices models.</p>
			</div>
		</div>
        <!-- <div class="list-section">
            <div class="records-section">
                <div class="records-count">
					<strong>{{ currentOperations.length }}</strong> Records
				</div>
            </div>
        </div> -->

        <div class="table-container">
            <table class="jobs-table">
                <thead>
                    <tr>
                        <th>Operation</th>
                        <th>Time</th>
                        <th>User ID</th>
                        <th>User Name</th>
                        <th>Device Model</th>
                        <th>Operation Status</th>
                        <th>Operation Error</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="currentOperations.length > 0; else noRecords">
                        <tr *ngFor="let operation of currentOperations; trackBy: trackByAuditId">
                            <td>{{ getEventTypeFor(operation.event_type) }}</td>
                            <td>{{ operation.timestamp ? (operation.timestamp | date:'yyyy-MM-dd HH:mm:ss') : '-' }}</td>
                            <td>{{ displayValue(operation.agent_id) }}</td>
                            <td>{{ displayValue(operation.agent_name) }}</td>
                            <td>{{ displayValue(operation.model) }}</td>
                            <td class="status-cell">
                                <img class="status-icon" [src]="operation.status === 'SUCCESS'
                              ? 'assets/success.svg'
                              : 'assets/failure.svg'" [alt]="operation.status">
                            </td>
                            <td class="error-message">
                                <div class="error-cell-content">
                                    <span class="error-text">{{ truncatedError(operation.error_message) }}</span>
                                    <button *ngIf="hasError(operation.error_message)" class="view-error-btn"
                                        (click)="viewError(operation.error_message)">View Error</button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>

                    <ng-template #noRecords>
                        <tr>
                            <td colspan="7" class="no-records">
                                {{ isLoading ? 'Loading records...' : 'No records found' }}
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>

        <div class="pagination-section" *ngIf="operationPages.length > 0">
            <div class="pagination">
                <button class="pagination-btn" (click)="previousPage()" [disabled]="isLoading || currentPage === 1">
                    Previous
                </button>
                <button class="pagination-btn active">{{ currentPage }}</button>
                <button class="pagination-btn" (click)="nextPage()" [disabled]="!canGoNext">
                    Next
                </button>
            </div>
        </div>
    </div>
</div>